import {Anchor} from 'antd';
import React from 'react';
import {Redirect} from 'react-router-dom';
import {useAccountStore} from './hooks/account-store';

const urlPrefix = process.env.REACT_APP_URL_PREFIX || '';

const Link = Anchor.Link;

interface MenuProps {
    admin: boolean;
}

function AppsMenu(props: MenuProps) {
    let permission;

    if(props.admin) {
        permission = <Link href={urlPrefix + '/permissions'} title="Update permissions"/>;
    }

    return (
        <div style={{minHeight: '100vh', display: 'flex'}}>
            <Anchor affix={false} style={{margin: 'auto'}}>
                <Link href={urlPrefix + '/offer-editor'} title="Offer editor"/>
                <Link href={urlPrefix + '/website-editor'} title="Website translator"/>
                <Link href={urlPrefix + '/popup-editor'} title="Popup editor"/>
                {permission}
            </Anchor>
        </div>
    );
}

export function Redirects() {
    const account = useAccountStore();

    let redirect;

    if (account.hasRole('translator')) {
        redirect = urlPrefix + '/website-editor';
    }

    if (!redirect) {
        return <AppsMenu admin={account.hasRole('admin', 'super_admin')}/>;
    }

    return (
        <Redirect to={redirect}/>
    );
}